import _sortedUniq from 'lodash/sortedUniq';
import { SIGHTENGINE_BASE_URL, SIGHTENGINE_API_USER, SIGHTENGINE_API_SECRET } from './constants';
import _get from 'lodash/get';
import { UPLOADED_VIDEO_STATUS_APPROVED, UPLOADED_VIDEO_STATUS_FAILED } from './constants';
import { getCloudFunctions } from '../system/firebase';
import { CLOUD_FUNCTION_NAME_MODERATE_TEXT } from '../system/constants';

// for Text fields checking
/**
 * @deprecated since 2022-10-26
 */
export const filterBadWords = async ({ data }) => {
    try {
        const body = new FormData();
        body.append('text', data);
        body.append('lang', 'en');
        body.append('opt_countries', 'us,gb,fr');
        body.append('mode', 'standard');
        body.append('api_user', SIGHTENGINE_API_USER);
        body.append('api_secret', SIGHTENGINE_API_SECRET);
        const response = await fetch(`${SIGHTENGINE_BASE_URL}/text/check.json`, {
            method: 'POST',
            body,
        });
        let dataToReturn = {};
        const responseData = await response.json();
        if (responseData?.status === 'success') {
            // console.log('responseData', responseData);
            dataToReturn = {
                profanity: _sortedUniq(responseData?.profanity?.matches?.map(o => o.match)),
                personal: responseData?.personal?.matches?.map(o => o.match),
                link: responseData?.link?.matches?.map(o => o.match),
            };
        }
        return dataToReturn;
    } catch (error) {
        console.log('error in filtering bad words', error);
    }
};

export const moderateUserTextInput = async ({ text = '' }) => {
    const functions = getCloudFunctions();
    const moderateText = functions.httpsCallable(CLOUD_FUNCTION_NAME_MODERATE_TEXT);

    let dataToReturn = {};

    try {
        const response = await moderateText({ text });
        const responseData = _get(response, 'data');

        if (responseData?.status === 'success') {
            // console.log('responseData', responseData);
            dataToReturn = {
                profanity: _sortedUniq(responseData?.profanity?.matches?.map(o => o.match)),
                personal: responseData?.personal?.matches?.map(o => o.match),
                link: responseData?.link?.matches?.map(o => o.match),
            };
        }
        return dataToReturn;
    } catch (error) {
        console.log('Failed to check for text violation', error);
        return null;
    }
};

// detecting any inappropriate Pictures
export const detectInappropriatePicture = async file => {
    try {
        let body = new FormData();
        body.append('media', file);
        body.append('models', 'nudity,wad,properties,celebrities,offensive,faces,scam,text-content,face-attributes,gore,text');
        body.append('api_user', SIGHTENGINE_API_USER);
        body.append('api_secret', SIGHTENGINE_API_SECRET);

        const response = await fetch(`${SIGHTENGINE_BASE_URL}/check.json`, {
            method: 'POST',
            body,
        });
        const responseData = await response.json();

        return responseData;
    } catch (error) {
        console.log('error in filtering bad pictures', error);
    }
};

// detecting any inappropriate Video
export const detectInappropriateVideo = async file => {
    try {
        let body = new FormData();
        body.append('media', file);
        body.append('models', 'nudity,wad,properties,celebrities,offensive,faces,scam,text-content,face-attributes,gore,text');
        body.append('api_user', SIGHTENGINE_API_USER);
        body.append('api_secret', SIGHTENGINE_API_SECRET);

        const response = await fetch(`${SIGHTENGINE_BASE_URL}/video/check-sync.json`, {
            method: 'POST',
            body,
        });
        const responseData = await response.json();

        return responseData;
    } catch (error) {
        console.log('error in filtering bad Video', error);
    }
};

// extract Bad Content from Picture
export const extractBadContentFromResult = async ({ seResult, setBadImageDialogMessage, setOpenBadImageDialog }) => {
    try {
        if (seResult) {
            seResult = JSON.parse(seResult);
            //   if (result?.status === 'success') {
            const alcohol = _get(seResult, 'alcohol');
            const drugs = _get(seResult, 'drugs');
            const offensive = _get(seResult, 'offensive');
            // const scam = _get(seResult, 'scam');
            const nuditySafe = _get(seResult, 'nudity.safe');
            // const nudity = _get(seResult, 'nudity');
            // const nudityTag = _get(seResult, 'nudity.partial_tag');
            const weapon = _get(seResult, 'weapon');
            // detecting inappropriate picture
            let badContentDetectedInPicture = [];
            if (alcohol > 0.05 || drugs > 0.03 || offensive > 0.05 || nuditySafe < 0.5 || /*scam > 0.07 ||*/ weapon > 0.05) {
                if (alcohol > 0.05) badContentDetectedInPicture.push('Alcohol');
                if (drugs > 0.03) badContentDetectedInPicture.push('Drugs');
                if (offensive > 0.05) badContentDetectedInPicture.push('Offense');
                if (nuditySafe < 0.5) badContentDetectedInPicture.push('Nudity');
                // if (scam > 0.07) badContentDetectedInPicture.push('Scam Content');
                if (weapon > 0.05) badContentDetectedInPicture.push('Weapons');
                const message = badContentDetectedInPicture.join(', ');
                if (message !== []) {
                    setBadImageDialogMessage(badContentDetectedInPicture.join(', '));
                    setOpenBadImageDialog(true);
                }
            } else setOpenBadImageDialog(false);
        }
    } catch (error) {
        console.log('Error in extractBadContentFromResult ', error);
    }
};

// simplyfying data as we did in cloud Function

export const simplifySighEngineResponse = result => {
    const seStatus = _get(result, 'status');

    if (seStatus === 'success') {
        const nudity = _get(result, 'nudity');
        const weapon = _get(result, 'weapon');
        const alcohol = _get(result, 'alcohol');
        const drugs = _get(result, 'drugs');
        const offensive = _get(result, 'offensive.prob');
        // const scam = _get(result, 'scam.prob');
        const profanity = _get(result, 'text.profanity')?.length;
        const text = _get(result, 'text');

        const seResult = JSON.stringify({ nudity, weapon, alcohol, drugs, offensive, /*scam,*/ text });

        //-------------------------------------------------------------------------------------------
        // Identify If Passes Test Or Not
        //-------------------------------------------------------------------------------------------

        let pictureStatus;

        if (nudity?.safe < 0.5 || weapon > 0.05 || alcohol > 0.05 || drugs > 0.03 || offensive > 0.05 || /*scam > 0.07 ||*/ profanity > 0)
            pictureStatus = UPLOADED_VIDEO_STATUS_FAILED;
        else pictureStatus = UPLOADED_VIDEO_STATUS_APPROVED;

        return { seResult, pictureStatus };
    }
};
